/* eslint-disable prefer-arrow-callback */
import crossFetch from 'cross-fetch'
import getErrorCode from '../utils/getErrorCode'
import { dummyServer } from '../config'


export default (url, options) => new Promise((resolve, reject) => {
  if (dummyServer) {
    return (async () => {
      try {
        const { dummyData, dummyFetch } = await import('./dummy')
        resolve(dummyFetch(url, dummyData))
      } catch (err) {
        reject({
          ...err,
          errorCode: getErrorCode(err),
        })
      }
    })()
  }

  crossFetch(url, options).then(res => {
    if (res.status === 401 || res.status === 403) {
      localStorage.removeItem('auth')
      window.location.href = `/login${window.location.search}`

      return null;
    }

    if (res.status === 413) {
      return reject({ errorCode: '0413' })
    }

    if (res.status === 201) {
      return resolve(res)
    }
    if (res.status !== 200) {
      return res.json().then(err => reject({
        ...err,
        errorCode: getErrorCode(err),
      }))
    }

    return resolve(res)
  }).catch((err) => {
    return reject({
      ...err,
      errorCode: getErrorCode(err),
    })
  })
})
